import { render, staticRenderFns } from "./RaschetRadiatorov.vue?vue&type=template&id=1d0f870f&lang=pug&"
import script from "./RaschetRadiatorov.vue?vue&type=script&lang=js&"
export * from "./RaschetRadiatorov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports